import { map, assign, isUndefined, isNil } from "lodash/fp";

class Controller {
  constructor(Events, $injector) {
    "ngInject";

    this.Events = Events;
    this.$injector = $injector;
  }

  $onInit() {
    const removeSource = (item) => {
      item = item._source ? assign({ _id: item._id }, item._source) : item;
      if (item.name) {
        item.name = item.note ? item.name + " -- " + item.note : item.name;
      } else {
        item.name = item.plates;
      }
      return item;
    };
    this.onAutoCompleteSearch = (text) => {
      const request = this.$injector
        .get(this.resource)
        .search(text, this.params);
      return request.$promise.then((list) => map(removeSource)(list.hits));
    };

    this.onChange = (selected) => {
      if (!isNil(selected)) {
        if (!isUndefined(this.extraParams)) {
          selected.extraParams = this.extraParams;
        }
        if (this.onSelect) this.Events.emit(this.onSelect, selected);
        if (this.onSelectEvent) this.Events.emit(this.onSelectEvent, selected);
      }
    };
  }

  clear() {
    this.selected = null;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/autocomplete/autocomplete.controller.js